import { Component, OnInit, ViewChild, ElementRef, OnDestroy, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { locale as English } from '../parameter-search/i18n/en';
import { locale as French } from '../parameter-search/i18n/fr';

@Component({
    selector: 'parameter-search',
    templateUrl: './parameter-search.component.html',
    styleUrls: ['./parameter-search.component.scss']
})
export class ParameterSearchComponent implements OnInit, OnDestroy, OnChanges {
    navigationItems: any[] = [];
    filteredNavigationItems: any[] = [];
    searching: boolean = false;
    @ViewChild('searchInput') searchInputField: ElementRef;
    @Input() navigation: any;

    private _unsubscribeAll: Subject<any> = new Subject();

    constructor(
        private _fuseNavigationService: FuseNavigationService,
        private _router: Router,
        private _translateService: TranslateService,
        private _translateLoaderService: FuseTranslationLoaderService
    ) {
        this._translateLoaderService.loadTranslations(English, French);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['navigation'] && changes['navigation'].currentValue) {
            this.initializeNavigation();
        }
    }

    ngOnInit(): void {
        this.initializeNavigation();
    }

    private initializeNavigation(): void {
        if (this.navigation) {
            // Trouver la section 'setting' dans la navigation
            const settingSection = this.navigation.find(item => item.id === 'setting');
            if (settingSection) {
                // Extraire tous les éléments de type 'item' sous 'setting'
                this.navigationItems = this.getSettingItems(settingSection);
                this.filteredNavigationItems = this.navigationItems;
            } else {
                this.navigationItems = [];
                this.filteredNavigationItems = [];
            }
        } else {
            this.navigationItems = [];
            this.filteredNavigationItems = [];
        }
    }

    private getSettingItems(section: any): any[] {
        const items: any[] = [];

        // Fonction récursive pour parcourir les enfants et extraire les éléments de type 'item'
        const extractItems = (children: any[]) => {
            if (!children) return;
            children.forEach(child => {
                if (child.type === 'item') {
                    items.push(child);
                } else if (child.children) {
                    extractItems(child.children);
                }
            });
        };

        // Extraire les items de la section 'setting'
        extractItems(section.children);
        return items;
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    search(event: any): void {
        const value = event.target.value.toLowerCase();

        if (value === '') {
            this.searching = false;
            this.filteredNavigationItems = this.navigationItems || [];
            return;
        }

        this.searching = true;
        this.filteredNavigationItems = (this.navigationItems || []).filter((navigationItem) => {
            return navigationItem?.title?.toLowerCase().includes(value);
        });
    }

    navigateToItem(item: any): void {
        if (item?.url) {
            this._router.navigate([item.url]);
            this.searching = false;
            this.searchInputField.nativeElement.value = '';
            this.filteredNavigationItems = this.navigationItems || [];
        }
    }

    onMenuOpen(): void {
        setTimeout(() => {
            this.searchInputField?.nativeElement.focus();
        });
    }
}